<template lang="pug">
  v-container(grid-list-md v-if="!$root.$children[0].loading")
    v-flex(md12)
      v-card.elevation-12

        v-toolbar(dark color="primary" dense)
          v-toolbar-title Reporte Servicios Móvil
          v-spacer
          v-btn(@click="closeSession()" flat)
            | Cerrar sesión
            v-icon(right) power_settings_new

        v-card-text
          v-layout(row wrap)
            v-flex(md2)
              v-select(
                v-model="month"
                label="Mes"
                :items="getMonths")
            v-flex(md2)
              v-select(
              v-model="year"
              label="Año"
              :items="getYears")

        v-card-text
          .loading-wrapper
            transition(name="fade" mode="out-in")
              .loading(v-if="localLoader" z-index="2")
                v-progress-circular.progress(:size=100 indeterminate)
            table(width="100%" align="center")
              thead
                tr
                  th Móvil - Turno
                  th Recos
                  th Zarpes
                  th RTX
                  th Total
                  th Monto
              tbody
                tr(v-for="driverServices in drivers" height="40")
                  //- td(align="center") {{ driverServices }}
                  //- td(width="200" @click="$router.push('/reporte/' + month + '/' + year + '/' + driverServices[0].driver_id)"): span.link-name {{ driverServices[0].names }} {{ driverServices[0].last_names }}
                  td(align="center" width="150" @click="getToken(driverServices[0].vehicle_id)"): span.link-name {{ driverServices[0].n_movil }}
                  td(align="center") {{ countRecos(driverServices) }}
                  td(align="center") {{ countZarpe(driverServices) }}
                  td(align="center") {{ countRtx(driverServices) }}
                  td(align="center") {{ countRecos(driverServices) + countZarpe(driverServices) + countRtx(driverServices) }}
                  td(align="center") {{ countServicesPrice(driverServices) }}

            table.mt-5.dense(width="100%" align="center" style="margin: auto")
              thead
                tr
                  th
                  th Porcentaje
                  th Monto
              tbody
                tr
                  td(align="center"): strong Total
                  td(align="center") 100%
                  td(align="center") {{ allServicesTotalMount | price }}
                tr
                  td(align="center"): strong Descuento
                  td(align="center") 20%
                  td(align="center") {{ allServicesTotalMount * 0.2 | price }}
                tr
                  td(align="center"): strong Liquido a pagar
                  td(align="center") 80%
                  td(align="center") {{ allServicesTotalMount * 0.8 | price }}

</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  moment.locale('es')

  export default {
    name: 'reportFlota',
    data: () => ({
      month: localStorage.getItem('month') ? localStorage.getItem('month') : moment().format('MMMM'),
      year: localStorage.getItem('year') ? parseInt(localStorage.getItem('year')) : parseInt(moment().format('gggg')),
      drivers: [],
      services: [],
      localLoader: false
    }),
    created () {
      this.$root.$children[0].loading = true
      this.moment = moment.locale('es')
      if (!localStorage.getItem('tokenFlota')) {
        this.$router.push('/')
      } else {
        this.loadData()
      }
    },
    computed: {
      getYears () {
        let years = []
        for (let year = 2017; year <= parseInt(moment().format('gggg')); year++) {
          years.push(year)
        }
        return years
      },
      getMonths () {
        let months = []
        for (let month = 1; month <= 12; month++) {
          months.push(moment(month, 'M').format('MMMM'))
        }
        return months
      },
      allServicesTotalMount () {
        if (!this.services.length) return '$ 0'
        return this.services.map(service => {
          return service.value
        }).reduce((oldValue, currentValue) => {
          return oldValue + currentValue
        })
      }
    },
    methods: {
      loadData () {
        // this.$root.$children[0].loading = false
        // persist month and year
        this.$root.$children[0].loading = true
        localStorage.setItem('month', this.month)
        localStorage.setItem('year', this.year)
        var headers = {}
        headers['Authorization'] = localStorage.getItem('tokenFlota')
        this.$http.get('vehicles', {
          params: {
            ownerID: localStorage.getItem('ownerID'),
            month: moment(this.month, 'MMMM').format('M'),
            year: this.year
          },
          headers
        }).then(res => {
          var drivers = _.groupBy(res.body, 'n_movil')
          this.drivers = _.pick(drivers, Object.keys(drivers).sort())

          this.services = res.body
          this.$root.$children[0].loading = false
        }).catch(res => {
          this.closeSession()
          this.$root.$children[0].loading = false
        })
      },
      countRecos (services) {
        let counter = 0
        services.forEach(service => {
          if (service.type === 'reco') counter++
        })
        return counter
      },
      countZarpe (services) {
        let counter = 0
        services.forEach(service => {
          if (service.type === 'zarpe') counter++
        })
        return counter
      },
      countRtx (services) {
        let counter = 0
        services.forEach(service => {
          if (service.type === 'rtx_reco' || service.type === 'rtx_zarpe') counter++
        })
        return counter
      },
      countServicesPrice (services) {
        let counter = 0
        services.forEach(service => {
          counter += service.value
        })
        return '$ ' + new Intl.NumberFormat('es-CL').format(counter)
      },
      getToken (vehicleId) {
        var headers = {}
        headers['Authorization'] = localStorage.getItem('tokenFlota')
        this.$root.$children[0].loading = true
        this.$http.get('getTokenPerVehicle', {
          params: {
            vehicleID: vehicleId
          },
          headers
        }).then(res => {
          localStorage.setItem('token', res.body)
          localStorage.setItem('vehicleID', vehicleId)
          setTimeout(() => {
            this.$root.$children[0].loading = false
            window.location.href = '/reporte'
          }, 1000)
        }).catch(res => {
          this.closeSession()
          this.$root.$children[0].loading = false
        })
      },
      closeSession () {
        localStorage.removeItem('month')
        localStorage.removeItem('year')
        localStorage.removeItem('token')
        localStorage.removeItem('vehicleID')
        localStorage.removeItem('tokenFlota')
        localStorage.removeItem('ownerID')
        setTimeout(() => {
          window.location.href = '/'
        }, 1000)
      }
    },
    watch: {
      month () {
        this.loadData()
      },
      year () {
        this.loadData()
      }
    },
    filters: {
      price (value) {
        return '$ ' + new Intl.NumberFormat('es-CL').format(parseInt(value))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/reportFlota.vue